import React, { Component } from "react";
import { view } from "react-easy-state";
import { widget } from "../dockable";
import store from "../state.js";
import HSVPicker from "../components/HSVPicker";
import css from "./Palette.module.css";
import Color from "color";

class Palette extends Component {
  static defaultProps = {
    colors: [
      { index: 0, color: [17, 16, 202] },
      { index: 1, color: [17, 16, 202] },
      // { index: 20, color: [28, 126, 202] }
      { index: 20, color: [0, 255, 0] }
      // { index: 200, color: [255, 0, 0] },
      // { index: 255, color: [255, 255, 255] }
    ],
    actions: () => [
      {
        type: "actions",
        actions: {
          "Palette Action": function() {
            console.log("This is a Palette Action");
          },
          "HSV Action": function() {
            console.log("This is an HSV Action");
          }
        }
      }
    ]
  };

  handleClick = (i, color) => {
    store.selectedIndex = i;
  };

  handleColorChange = color => {
    store.palette[store.selectedIndex] = color;
  };

  getFullColorRamp = () => {
    let fullColors = [];

    let index = 0;
    let lastSparseIndex = 0;
    this.props.colors.forEach((color, sparseIndex) => {
      for (let i = index; i <= color.index; i++) {
        let a = Color.rgb(this.props.colors[lastSparseIndex].color);
        let b = Color.rgb(color.color);
        let d = color.index - this.props.colors[lastSparseIndex].index;
        let l = d ? (i - this.props.colors[lastSparseIndex].index) / d : 1;
        let lerpColor = a.mix(b, l);

        lerpColor = lerpColor.rgb().array();

        fullColors.push({
          color: lerpColor,
          index: i,
          tween: color.index !== i
        });
        index++;
      }
      lastSparseIndex = sparseIndex;
    });

    return fullColors;
  };

  renderPaletteGrid = () => {
    let paletteGrid = [];
    let fullRamp = this.getFullColorRamp();
    for (let rowIndex = 0; rowIndex < 16; rowIndex++) {
      let row = [];
      for (let colIndex = 0; colIndex < 16; colIndex++) {
        let index = colIndex + 16 * rowIndex;
        row.push(
          fullRamp[index] ? (
            <ColorIndex
              key={index}
              index={fullRamp[index].index}
              color={fullRamp[index].color}
              selected={store.selectedIndex === fullRamp[index].index}
              onClick={this.handleClick}
              // tween={fullRamp[index].tween}
            />
          ) : (
            <div key={colIndex} className={css.nullIndex} />
          )
        );
      }
      paletteGrid.push(
        <div key={rowIndex} className={css.paletteRow}>
          {row}
        </div>
      );
    }
    return paletteGrid;
  };

  renderPaletteRamp = (reverse?) => {
    let ramp = reverse
      ? this.getFullColorRamp().reverse()
      : this.getFullColorRamp();
    return (
      <div
        className={css.paletteRow}
        style={{
          marginBottom: 10,
          borderRadius: 2,
          overflow: "hidden"
        }}
      >
        {ramp.map((index, i) => (
          // <ColorIndex key={i} index={i} color={index.color} tween={false} />
          <div
            key={i}
            style={{
              backgroundColor: `RGB(${index.color[0]}, ${index.color[1]}, ${
                index.color[2]
              })`,
              flexGrow: 1,
              width: 16,
              height: 16
            }}
          />
        ))}
      </div>
    );
  };

  renderRampGradient = (angle, stepped) => {
    let prevColor = null;
    let colors = this.getFullColorRamp();
    stepped = stepped ? stepped : 0;
    return `linear-gradient(${angle ? angle : 90}deg, ${colors.map(color => {
      let position =
        (color.index / (colors[colors.length - 1].index + stepped)) * 100;
      let newColor = `rgb(${color.color})`;
      let thisPrevColor = stepped
        ? prevColor
          ? `${prevColor} ${position}%,`
          : ""
        : "";
      let thisColor = `${thisPrevColor} ${newColor}  ${position}%`;
      prevColor = newColor;
      return thisColor;
    })})`;
  };

  render() {
    return (
      <div className={css.container}>
        {/* <div style={{ display: "block" }}>
          {[...new Array(1)].map((a, i) => (
            <div
              className={css.paletteRow}
              style={{
                background: this.renderRampGradient(90, true),
                // width: 32,
                height: 20,
                marginRight: 4,
                marginBottom: 10,
                borderRadius: 3,
                boxShadow: "0 1px 1px rgba(0,0,0,0.5)"
              }}
            />
          ))}
        </div> */}
        {/* {this.renderPaletteRamp()}
        {this.renderPaletteRamp(true)}
        {this.renderPaletteRamp()}
        {this.renderPaletteRamp(true)} */}
        <div
          style={{
            flexGrow: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "stretch",
            backgroundColor: "#343434",
            padding: 3,
            borderRadius: 3
          }}
        >
          {this.renderPaletteGrid()}
        </div>
        <div style={{ clear: "both", height: 10, flexShrink: 0 }} />
        <HSVPicker
          color={store.palette[store.selectedIndex]}
          onChange={this.handleColorChange}
        />
      </div>
    );
  }
}

class ColorIndex extends Component {
  handleClick = () => {
    this.props.onClick &&
      this.props.onClick(this.props.index, this.props.color);
  };
  render() {
    let thisColor = `RGB(${this.props.color[0]}, ${this.props.color[1]}, ${
      this.props.color[2]
    })`;
    return (
      <div
        onClick={this.handleClick}
        className={[
          this.props.tween ? css.tween : css.index,
          this.props.tween && this.props.index % 16 === 0 ? css.firstTween : "",
          this.props.tween && this.props.index % 16 === 15 ? css.lastTween : ""
        ].join(" ")}
        style={{
          backgroundColor: thisColor,
          color: thisColor
        }}
      >
        {this.props.selected ? <div className={css.selected} /> : null}
      </div>
    );
  }
}

export default view(
  widget(Palette, {
    id: "Palette",
    minHeight: 360
  })
);
